import { Helmet } from "react-helmet-async";
import { useLpConfig } from "routes/LandingPage/LpConfigContext";

/**
 * LP の <head>（タイトルと meta）。設定の `meta` を読む
 * @return {JSX.Element} Helmet
 */
export function LpMeta() {
  const { meta } = useLpConfig();

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <meta property="og:title" content={meta.ogTitle} />
      <meta property="og:description" content={meta.ogDescription} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
